export const iconFontAwesomeToggleToggleOff = (
	<i className="fa-solid fa-toggle-off"></i>
);
